var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 1.83337C4.31802 1.83337 1.33325 4.81814 1.33325 8.50004C1.33325 12.1819 4.31802 15.1667 7.99992 15.1667C11.6818 15.1667 14.6666 12.1819 14.6666 8.50004C14.6666 4.81814 11.6818 1.83337 7.99992 1.83337ZM6.66659 7.83337C6.66659 7.46518 6.96506 7.16671 7.33325 7.16671H7.99992C8.36811 7.16671 8.66659 7.46518 8.66659 7.83337V11.1667C8.66659 11.5349 8.36811 11.8334 7.99992 11.8334C7.63173 11.8334 7.33325 11.5349 7.33325 11.1667V8.50004C6.96506 8.50004 6.66659 8.20156 6.66659 7.83337ZM7.99992 5.16671C7.63173 5.16671 7.33325 5.46518 7.33325 5.83337C7.33325 6.20156 7.63173 6.50004 7.99992 6.50004C8.36811 6.50004 8.66659 6.20156 8.66659 5.83337C8.66659 5.46518 8.36811 5.16671 7.99992 5.16671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.1de77b109823c8e9488466c3e7225d5c.svg";
export { ForwardRef as ReactComponent };